import domReady from '../utils/domReady';

let cards = [
    {'text-cards basic-card':'footer a'}
];

domReady.then(()=>{
    cards.forEach( card => Object.keys(card).forEach( selector => {
        [...document.querySelectorAll(selector)].forEach((element,key) => {
            let link = element.querySelector(card[selector]),
                href = (link || document.createElement('a')).getAttribute('href');
            if(!!href) {
                element.classList.add('clickable');
                element.addEventListener('click', event => {
                    if(event.target !== link){
                        link.click();
                        return false;
                    }
                }, false);
            }
        });    
    }));
});